// @flow

import React from 'react';
import { SelectProps } from 'antd/lib/select';

import { crewApi } from './../../lib/api';
import AutocompleteSelect from './AutocompleteSelect';

type Props = SelectProps & { filter: any };

export default ({ filter = {}, ...selectProps }: Props) => (
  <AutocompleteSelect
    fetch={async params => {
      return await crewApi.fetch({
        ...filter,
        ...params
      });
    }}
    refetchParams={{ filter }}
    fetchSingle={crewApi.fetch}
    notFoundText="Бригады не найдены"
    placeholder="Выберите бригаду"
    renderOption={(crew: any, Option) => (
      <Option key={crew.id} value={crew.id} crew={crew}>
        {crew.name}
      </Option>
    )}
    {...selectProps}
  />
);
